export enum RollCompetitionsEntriesQueryKeys {
  Primary = 'roll-competition-entries',
  Me = 'roll-competition-entries/me',
  Validate = 'roll-competition-entries/validate',
  Awards = 'roll-competition-entries/awards',
}
